import React from 'react';
import { Box, IconButton, Tooltip, Menu, MenuItem, Typography, ListItemText } from '@mui/material';
import { useTranslation, supportedLanguages } from './LanguageContext';

const LanguageSelector = ({ sx = {} }) => {
  const { language, setLanguage, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelectLanguage = (langCode) => {
    setLanguage(langCode);
    handleClose();
  };

  const currentLang = supportedLanguages.find(l => l.code === language);

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', ...sx }}>
      <Tooltip title={t('language.label')}>
        <IconButton
          onClick={handleOpen}
          size="small"
          sx={{
            color: 'inherit',
            fontSize: '0.9rem',
            borderRadius: '8px',
            padding: '4px 8px',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
          }}
        >
          <Typography component="span" sx={{ mr: 0.5, fontSize: '1.1rem' }}>
            {currentLang?.flag}
          </Typography>
          <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
            {currentLang?.code?.toUpperCase()}
          </Typography>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {supportedLanguages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleSelectLanguage(lang.code)}
            selected={lang.code === language}
            sx={{ minWidth: 150 }}
          >
            <Typography component="span" sx={{ mr: 1.5, fontSize: '1.1rem' }}>
              {lang.flag}
            </Typography>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;